/*
 * this factory adds the react-redux provider
 * */
import { Provider } from 'react-redux'
import React from 'react'
import ReactDOM from 'react-dom'

export default class DomFactory {
  constructor(store = null) {
    /**
     * The redux store
     */
    this.store = store
  }

  /**
   * Injects a react component
   * @param {object}			module		- The react component
   * @param {object}			props		- Props to initiate component with
   * @param {HTMLElement}		target		- The target element to inject to
   */
  inject(module, props = {}, target) {
    if (target) {
      ReactDOM.render(
        <Provider store={this.store}>
          {React.createElement(module, props || {})}
        </Provider>,
        target
      )
    } else {
      // eslint-disable-next-line
      console.warn('RHW07', 'Target element is null or undefined.')
    }
  }

  /**
   *  Disposes a react component
   * @param {HTMLElement}		target		- The target element to dispose
   */
  dispose(target) {
    if (target) {
      ReactDOM.unmountComponentAtNode(target)
    }
  }
}
